exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-nav[data-v-3f955058] {\n  left: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  -webkit-transition: 0.66s opacity;\n  transition: 0.66s opacity;\n  width: 100%;\n  z-index: 1000;\n}\n.fixed-nav.shown[data-v-3f955058] {\n  height: auto;\n  opacity: 1;\n}", ""]);

// exports
